export default __webpack_public_path__ + "static/guide-eb762fdc63103d030deb3086978569c9.svg";